module.exports = __webpack_public_path__ + "media/images/ai_brain_topics/delivery_missing-d88610ed53df2b15160f749268fe22d4.png";